import { render, staticRenderFns } from "./SurchargeWaiver.vue?vue&type=template&id=2e234a7c&scoped=true&"
import script from "./SurchargeWaiver.vue?vue&type=script&lang=js&"
export * from "./SurchargeWaiver.vue?vue&type=script&lang=js&"
import style0 from "./SurchargeWaiver.vue?vue&type=style&index=0&id=2e234a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e234a7c",
  null
  
)

export default component.exports